import React 			from 'react';
import PropTypes 	from 'prop-types';

import {onEscapePress} from '../../common/_Utilities.jsx';

export default class CategoryModalFrame extends React.Component
{
	constructor(props) 
	{
		super(props);

		this.state = {}
	}

	componentDidMount() {
		onEscapePress(() => this.props.closeFunc());
	}

	componentDidUpdate() {
		onEscapePress(() => this.props.closeFunc());
	}

	render() {
		const {classes = '', title, closeFunc, footer = null, backFunc = null, closeOutsideClicked = true, showCloseBtn = true, stickyHeader = false, isCustom = false} = this.props;

		return (
			<div className={"modal modal--no-padding-body " + classes}>
				<div className="modal__overlay" onClick={closeOutsideClicked ? () => closeFunc() : null}></div>
				<div className={"modal__content" + (footer && footer.sticky ? ' modal__content--sticky-footer' : '') + (stickyHeader ? ' modal__content--sticky-header' : '')}>
					{title ?
						<div className="modal__header bg-color--cloud">
							<div className="modal__title">{backFunc ? <button className="btn btn--blank" onClick={() => backFunc()}><i className="fas fa-long-arrow-left l-margin-right--sm"/></button> : null}{title}</div>
							{showCloseBtn ? <i className="far fa-times modal__close" onClick={() => closeFunc()}></i> : null}
						</div>
					: null}
					{isCustom ? 
						this.props.children
					:
						<React.Fragment>
							<div className="modal__body">
								{this.props.children}
							</div>
							{footer ? this.renderFooter() : null}
						</React.Fragment>
					}
				</div>
			</div>
		);
	}

	renderFooter() {
		const buttons 		= this.props.footer.buttons;
		const buttonItems = {left: [], center: [], right: []};

		buttons.map((button, key) => {
			const buttonTypeClass 	= button.type ? `btn--${button.type}` : '';
			const disabled = button.disabled || false;
			
			buttonItems[button.align || 'left'].push(
				<button key={key} className={`btn ${buttonTypeClass} ${button.classes || ''}`} disabled={disabled} onClick={disabled ? null : () => button.onClickFunc()} dangerouslySetInnerHTML={{__html: button.text}}/>
			);
		});

		const leftButtons 	= buttonItems.left.length ? <div className="modal__footer-left">{buttonItems.left}</div> : '';
		const centerButtons = buttonItems.center.length ? <div className="modal__footer-center">{buttonItems.center}</div> : '';
		const rightButtons 	= buttonItems.right.length ? <div className="modal__footer-right">{buttonItems.right}</div> : '';

		return <div className="modal__footer modal__footer--frame">{leftButtons}{centerButtons}{rightButtons}</div>;
	}
}

CategoryModalFrame.propTypes = {
		classes: PropTypes.string
	,	title: PropTypes.string
	,	closeFunc: PropTypes.func.isRequired
	,	backFunc: PropTypes.func
	, isCustom: PropTypes.bool //this is for if you want to just have the header and frame but custom footer etc
	, stickyHeader: PropTypes.bool
	,	footer: PropTypes.shape({
			sticky: PropTypes.bool
		,	buttons: PropTypes.arrayOf(PropTypes.shape({
				text: PropTypes.string.isRequired
			,	onClickFunc: PropTypes.func.isRequired
			, type: PropTypes.oneOf(['cta', 'cta-alt', 'link'])
			, align: PropTypes.oneOf(['left', 'center', 'right'])
			, classes: PropTypes.string
			, disabled: PropTypes.bool
		}))
	})
}